import data from "@/config/template/List/data.json"
import { CurrentAppResp } from "@/page/App/resp/currentAppResp"

export const LIST_DATA = data as unknown as CurrentAppResp
